class PromoPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closePromo.bind(this));

    // Quand on clique sur le bouton CTA, on enregistre aussi
    this.ctaButton = this.querySelector(".promo-popup__cta");
    if (this.ctaButton) {
      this.ctaButton.addEventListener("click", this.onCtaClick.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("promo-closed");
    this.clicked = getCookie("promo-clicked");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closePromo() {
    setCookie("promo-closed", "true");
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("promo-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("promo-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.clicked !== "true") {
        this.show();
      }
    }, this.delay);
  }

  onCtaClick() {
    setCookie("promo-clicked", "true");
    this.hide();
  }
}

customElements.define("promo-popup", PromoPopup);

